import { observable } from "mobx";
import { Type } from "class-transformer";
import CustomerRefundCandidateRefundPaymentRequest from "./customerRefundCandidateRefundPaymentRequest";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CustomerRefundCandidateUpdateRequest {
  @observable
  isWithoutRefundFee?: boolean;

  @observable
  @Type(() => CustomerRefundCandidateRefundPaymentRequest)
  refundPayment?: CustomerRefundCandidateRefundPaymentRequest;
}
